<template>
  <div>
    <page-intro>
      <template v-slot:heading>Дополнительные опции</template>
      <template v-slot:info>
        Добавляйте новое дисковое пространство, подключайте новые инструменты
      </template>
    </page-intro>
    <div class="stack-md">
      <disk-space />
      <sql-activation />
      <activated-services />
      <options-list />
    </div>
  </div>
</template>

<script>
  import PageIntro from '@/components/PageIntro.vue'
  import OptionsList from './OptionsList.vue'
  import ActivatedServices from './ActivatedServices.vue'
  import SqlActivation from './SqlActivation.vue'
  import DiskSpace from './DiskSpace.vue'

  export default {
    components: {
      PageIntro,
      DiskSpace,
      ActivatedServices,
      OptionsList,
      SqlActivation
    }
  }
</script>
